import { Parallel, type MaxLessonsPerDay } from 'shared/api';

export const maxLessonsPerDayCreateConfig: Partial<MaxLessonsPerDay> = {
  parameters: Object.values(Parallel).map((parallel) => ({
    parallel,
  })),
};
